<template>
	<div>
		<van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink"
			:disabled='disabled' :readonly="readonly" @focus="onFocus" :required="required"
			:rules="[{ required: required, message: label+'不可为空' }]" />
		<div class="van-hairline--bottom"></div>
		<van-action-sheet v-model="show" name="abc" :title="title" class="action-sheet-box">
			<!-- 搜索区域 -->
			<van-search v-model="search" placeholder="请输入关键词" @input="OnInput"></van-search>
			<van-cell v-for="(item,index) in dataList.filter(obj=>obj.departmentName.indexOf(search)!=-1)" :key="index"
				:title="item.departmentName" :is-link="isLink" @click="onSelect(item)">
			</van-cell>
		</van-action-sheet>
	</div>
</template>

<script>
	export default {
		name: 'DepartmentSelect',
		props: {
			label: {
				type: String,
				default: '未定义'
			},
			placeholder: {
				type: String,
				default: '请选择'
			},
			title: {
				type: String,
				default: '请选择'
			},
			dictid: {},
			value: {
				default: ''
			},
			disabled: {
				type: Boolean
			},
			isLink: {

			},
			selectkey: {
				default: "",
			},
			// 是否必填
			required: {
				type: Boolean,
				default: false
			},
			hosId: {

			},
			//是否存在单位过滤条件
			hasEmployerGuid: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				search: "",
				selectValue: this.value,
				// isLink: true,
				readonly: true,
				show: false,
				dataList: [],
				//二级联动，记录当前的单位id
				selectHosValue: '',
			}
		},
		watch: {
			// value(newVal) {
			//   setTimeout(() => {
			//     if (newVal.indexOf(',') != -1) {
			//       let newDepart = newVal.split(',')
			//       let newDepartGuid = []
			//       newDepart.forEach(item => {
			//         console.log(item);
			//         newDepartGuid.push(this.dataList.find(mod => mod.guid == item))
			//         // console.log(this.dataList.find(mod => mod.guid == item));
			//       })
			//       console.log(newDepartGuid);
			//       let newDepartNameList = []
			//       newDepartGuid.forEach(item => {
			//         newDepartNameList.push(item.departmentName)
			//       })
			//       this.selectValue = newDepartNameList.toString()
			//     }else{
			//        console.log(newVal);
			//         console.log(this.dataList.find(mod => mod.guid == newVal));
			//         this.selectValue=this.dataList.find(mod => mod.guid == newVal).departmentName

			//     }

			//   }, 200);
			// },
			selectkey(newVal) {
				let that = this
				let filterList = that.dataList.filter(m => m.guid == newVal)
				if (filterList.length > 0) {
					that.selectValue = filterList[0].departmentName
				}
			},
			//观察hosId变化
			hosId(newVal) {
				// 单位变化，将当前单位选中，并将当前科室清空，重新获取数据
				this.selectHosValue = newVal;
				this.initData();
			}
		},
		methods: {
			onFocus: function() {
				this.show = true
			},
			//搜索框变化事件
			OnInput: function() {
				//this.LoadItem()
			},
			onSelect: function(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show = false
				this.selectValue = item.departmentName
				this.$emit('input', this.selectValue)
				this.$emit('update:selectkey', item.guid)
				this.$emit('update:secondkey', "")
			},
			initData: function() {
				let args = {
					currentPage: 1,
					pageSize: 9999,
					menuid: this.$utils.MenuEnum.department
				}
				var that = this
				that.$utils.HttpPost(this.$utils.Url.system + '/api/APISEMP_Department/AllList', args, function(data) {
					if (that.selectHosValue) {
						that.dataList=[]
						data.data.forEach((item) => {
							for (var key in item) {
								item[that.$utils.toLowerCaseFirst(key)] = item[key]
							}
							if (item.employerGuid == that.selectHosValue) {
								that.dataList.push(item)
							}
						})

					}

					//如果不存在单位ID过滤条件，直接返回所有的科室列表
					if (!that.hasEmployerGuid) {
						that.options = data.data
						return;
					}



					if (that.selectkey) {
						let filterList = that.dataList.filter(m => m.guid == that.selectkey)
						if (filterList.length > 0) {
							that.selectValue = filterList[0].departmentName
						}
					}
					// for (var i = 0; i < data.Data.length; i++) {

					//   that.actions.push(arg)
					// }
				}, null, null)
			},
		},
		mounted: function() {
			this.selectHosValue = this.hosId;
			this.initData()
		}
	}
</script>

<style>
</style>
